import { BottomNavigationController } from '@ocx/feat-bottom-navigation';

import { useHomeRefresh } from '../context/home-refresh.context';

export const HomeBottomNavigationController = () => {
  const { refreshing } = useHomeRefresh();
  return <BottomNavigationController loading={refreshing} />;
};
